<div class="flex flex-col">
    <div class="inline-flex w-full bg-tertiary-100 rounded-full" role="group">
        @for (option of options; track option.value; let i = $index) {
            <button
                [id]="option.value"
                type="button"
                (click)="onValueSelected(option.value)"
                (keydown.enter)="onValueSelected(option.value)"
                [class]="
                    isSelected(option.value)
                        ? 'bg-primary-600 text-white'
                        : 'bg-tertiary-100 text-tertiary-900'
                "
                class="leading-tight w-full h-12 relative flex items-center justify-center gap-1.5 px-4 text-sm font-medium rounded-full transition-all duration-150 cursor-pointer"
            >
                <span>{{ option.label }}</span>
                @if (option.description) {
                    <span
                        class="font-medium"
                        [class]="
                            isSelected(option.value)
                                ? 'text-secondary-400'
                                : 'text-primary-800'
                        "
                        >{{ option.description }}</span
                    >
                }
            </button>
        }
    </div>
</div>
